module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    on: {
      "enter": _vm.onPageEnter,
      "leave": _vm.pageFadeOut
    }
  }, [_c('keep-alive', [_c('Object3D', {
    ref: "sub-page-content"
  }, [_c('RingCounter', {
    ref: "ring-counter",
    attrs: {
      "totalTime": 3000,
      "vms": "@play@countdown@ring-counter"
    },
    on: {
      "done": function () {
        if (_vm.isViewingPage) {
          _vm.$router.push({
            path: '/nike/game/play/record'
          })
        }
      }
    }
  }), _vm._v(" "), _c('NumberCounter', {
    ref: "number-counter",
    attrs: {
      "totalTime": 3000,
      "vms": "@play@countdown@number-counter"
    },
    on: {
      "done": function () {
        if (_vm.isViewingPage) {
          // $router.push({ path: '/nike/game/play/record' })
        }
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-616f4514","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NikeWebGL/Pages/Play/Countdown.vue
// module id = 596
// module chunks = 0